var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWithdrawFill = function SvgWithdrawFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.02 3h3.58v3.478z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.3 21.6a9.3 9.3 0 1 1 0-18.6 9.3 9.3 0 0 1 0 18.6m1.537-9.716v1.14h1.551V8.764h-4.261v1.55h1.363l-4.162 4.163 1.459 1.459z",
    clipRule: "evenodd"
  })));
};
export default SvgWithdrawFill;